module.exports = __webpack_public_path__ + "static/rooms02-8fc09b6a7f3efe757dc6d926590dd3ff.jpg";